const OFFICE_VIEWER_URL = 'https://view.officeapps.live.com/op/view.aspx?src=';

const isOfficeDocument = (attachmentType: string): boolean => /.?(word|powerpoint|excel)/.test(attachmentType);

export const getFixedAttachmentUrl = (attachmentType: string, distantUri: string): string => {
  if (!distantUri) return '';

  const prefix = isOfficeDocument(attachmentType) ? OFFICE_VIEWER_URL : '';
  return `${prefix}${encodeURI(distantUri)}`;
};

export const openFixedAttachment = (attachmentType: string, distantUri: string): void => {
  const url = getFixedAttachmentUrl(attachmentType, distantUri);
  if (!url) return;

  window.open(url);
};
